import { render, staticRenderFns } from "./ButtonPrimary.vue?vue&type=template&id=d5928fd4"
import script from "./ButtonPrimary.vue?vue&type=script&lang=js"
export * from "./ButtonPrimary.vue?vue&type=script&lang=js"
import style0 from "./ButtonPrimary.vue?vue&type=style&index=0&id=d5928fd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports